import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentCreatorInvite from './content-creator-invite-model'
import {
  delete_contentCreatorInvite,
  load_contentCreatorInvites,
  store_contentCreatorInvite,
} from './contentCreatorInvite-service'

export const LoadContentCreatorInvitesAsync = createAsyncThunk<any, any>(
  'composer/load/contentCreatorInvite',
  async (params: { uid: string }) => {
    return await load_contentCreatorInvites(params)
  },
)

export const CreateContentCreatorInviteAsync = createAsyncThunk<any, any>(
  'composer/create/contentCreatorInvite',
  async (params: ContentCreatorInvite) => {
    return await store_contentCreatorInvite(params)
  },
)

export const DeleteContentCreatorInviteAsync = createAsyncThunk<any, any>(
  'composer/delete/contentCreatorInvite',
  async (params) => {
    return await delete_contentCreatorInvite(params)
  },
)
